// Reusable Modal Form for Category and Brand Creation
import { useState } from 'react';
import axios from '../api/axios';

export default function AddCategoryBrandModal({ isOpen, onClose, type, onCreated }) {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!name.trim()) return;
        setLoading(true);
        try {
            const endpoint = type === 'category' ? '/meta/categories' : '/meta/brands';
            const res = await axios.post(endpoint, { name });
            onCreated(res.data); // Pass new category/brand back to parent
            setName('');
            onClose();
        } catch (err) {
            alert('Failed to create.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-md w-96">
                <h2 className="text-lg font-bold mb-4">Add New {type === 'category' ? 'Category' : 'Brand'}</h2>
                <input
                    type="text"
                    placeholder={`Enter ${type} name`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="border w-full p-2 rounded mb-4"
                />
                <div className="flex justify-end gap-3">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded">
                        Cancel
                    </button>
                    <button
                        onClick={handleCreate}
                        disabled={loading}
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
}
